class ProductDetailNavigation extends Component {
    constructor(el) {
        super(el);
        this.sections = document.querySelectorAll('[data-product-detail-nav]');
        this.navItems = this.$findAll('[data-product-detail-nav-item]');
        this.activeClass = 'is-active';
        this.options = { threshold: 0.3 };
        this.initObserver();
    }

    changeNav(entries){
        entries.forEach(({ isIntersecting, target }) => {
            if (isIntersecting) {
                this.navItems.forEach(navItem => {
                    if (navItem.dataset.id === target.id) {
                        navItem.classList.add(this.activeClass);
                        return;
                    }

                    navItem.classList.remove(this.activeClass);
                });
            }
        }, this);
    }

    initObserver() {
        const observer = new IntersectionObserver(this.changeNav.bind(this), this.options);

        this.sections.forEach(section => {
            observer.observe(section);
        });
    }
}
